// Small reusable "export these rows to an .xlsx" helper (bold header + auto-ish column widths).
// Used by the pages that already have an Excel IMPORT, to offer a matching EXPORT.

/* eslint-disable @typescript-eslint/no-explicit-any */

export type Cell = string | number | null | undefined;

export async function exportSheet(
  filename: string,
  sheetName: string,
  headers: string[],
  rows: Cell[][],
): Promise<void> {
  const mod: any = await import('xlsx-js-style');
  const XLSX = mod.default ?? mod;
  const aoa: Cell[][] = [headers, ...rows];
  const ws = XLSX.utils.aoa_to_sheet(aoa);

  const headerStyle = {
    font: { bold: true, sz: 11 },
    fill: { fgColor: { rgb: 'E7ECEF' } },
    alignment: { vertical: 'center' },
  };
  headers.forEach((_, c) => {
    const addr = XLSX.utils.encode_cell({ r: 0, c });
    if (ws[addr]) ws[addr].s = headerStyle;
  });

  ws['!cols'] = headers.map((h, c) => {
    const widest = Math.max(h.length, ...rows.map((r) => String(r[c] ?? '').length));
    return { wch: Math.min(48, Math.max(8, widest + 2)) };
  });
  ws['!freeze'] = { xSplit: 0, ySplit: 1 };

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName.slice(0, 31));
  XLSX.writeFile(wb, filename);
}
